import { observer } from "mobx-react-lite";
import "../../style/Play_Result.css";
import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router";
import { useGameStore, useProfilStore, useAlbumStore } from "../../stores/useStore";
import { useAnimatedValue } from "../../hooks/animatedValue";
import AlbumDetail from "../../components/album/AlbumDetail";
import Confetti from '@tholman/confetti';

const GROUPMODE = true;
const ALLMODE = false;

const Result = observer(() => {
  const location = useLocation();
  const {
    reason
  } = location.state || {};
  const gameStore = useGameStore();
  const albumStore = useAlbumStore();
  const profilStore = useProfilStore();
  const { newScore, start } = useAnimatedValue(profilStore.score, profilStore.score + gameStore.score, 1.5);
  const [showFirst, setShowFirst] = useState(false);
  const [showSecond, setShowSecond] = useState(false);

  useEffect(() => {
    start();
    // si le score a changé on l'update
    if (gameStore.score) {
      console.log("gameStore.score");
      console.log(gameStore.score);
      profilStore.updateScore(gameStore.score);
    }

    // on charge les ressources au bout d'un timer
    const timer1 = setTimeout(() => setShowFirst(true), gameStore.score?1000:0); // 1 seconde
    const timer2 = setTimeout(() => setShowSecond(true), gameStore.score?1300:0); // 1.3 secondes


    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);


  return (
    <section className="play_result_content">
        <div className="play_result_scoreDiv">
            <p className="play_result_scoreLabel">Votre score total :</p>
            <p className="play_result_scoreText">{`${isNaN(Math.round(newScore))?profilStore.score:Math.round(newScore)} (+${gameStore.score})`}</p>
        </div>
        <div className={`play_result_correctionDiv ${showFirst?``:`play_result_hide`}`}>
          <h2 className="play_result_correctionLabel">Récapitulatif de la partie :</h2>
          <ul className="play_result_albumList">
            {
              gameStore.userAlbumList.map(({album, correction})=>
                <li key={album.id}>
                  <AlbumDetail className="play_result_albumDetail" album={album} group={albumStore.getGroupById(album.groupId)} correction={correction} showTitle={true} showGroup={true} showCorrectionOnFlip={true}/>
                </li>
              )
            }
          </ul>
        </div>
        <div className={`play_result_informationDiv ${showSecond?``:`play_result_hide`}`}>
            <div className="play_result_informationParamDiv">
              <h3 className="play_result_informationParamTitle">Paramètres de jeu :</h3>
              {reason==="no-life"?
                <p>{`Vous avez perdu vos ${gameStore.lifeMax} vie${gameStore.lifeMax==1?"":"s"} et avez survécu ${gameStore.round} round${gameStore.round==1?"":"s"}.`}</p>:
                <p>{`Vous avez jouer avec ${gameStore.filterAlbumMode===ALLMODE?`tout les groupes`:albumStore.getGroupById(gameStore.groupId).name}.`}</p>
              }
              {reason==="no-life"?
                null:
                <p>{`Sur les ${gameStore.round-1} albums à trier, vous en avez trouvé ${gameStore.userAlbumList.reduce((acc, album)=>album.correction?acc+1:acc,0)-1}`}</p>
              }
            </div>
            <div className="play_result_informationScoreDiv">
              <h3 className="play_result_informationScoreTitle">Score obtenu :</h3>
              <p>{`Vous avez gagné ${gameStore.score} points dans cette partie.`}</p>
            </div>
        </div>
        <div className="play_result_linkDiv">
            <NavLink className={"play_result_linkPlay"} to="/play/param"><p>Rejouer</p></NavLink>
            <NavLink className={"play_result_linkProfil"} to="/profil"><p>Voir Mon profil</p></NavLink>
        </div>
        {
          // Components que j'ai trouvé qui génere des confettis
          reason==="no-life" || gameStore.scoreMax === gameStore.score?<Confetti style={{zIndex:10000}} total={200} />:null
        }
    </section>
  );
});

export default Result;
